<template>
  <div class="docs-header">
    <!--<div class="title col-24">
      <span>{{ title }}</span>
    </div>
    <div v-if="showFilter" class="filter col-24 col-sm-8 offset-sm-8">-->
    <div v-if="showFilter === 'SI'" class="filter col-24">
      <div class="month">
        <el-select :clearable="false" v-model="months" placeholder="" @change="changeMonth(months)"
          class="input-custom">
          <el-option v-for="item in listMonths" :key="item" :label="getLabel(item)" :value="item">
          </el-option>
        </el-select>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DocsHeader',
  props: ['route', 'showFilter', 'title', 'defaultMonths'],
  data() {
    return {
      docs: [],
      loading: false,
      listMonths: [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      months: 0
    }
  },
  i18n: {
    messages: {
      it_IT: {
        docsHeader: {
          label: 'Ultimi {months} Mesi'
        }
      },
      fr_FR: {
        docsHeader: {
          label: 'Derniers {months} mois'
        }
      },
      es_ES: {
        docsHeader: {
          label: 'Últimos {months} meses'
        }
      },
      de_DE: {
        docsHeader: {
          label: 'Letzten {months} Monaten'
        }
      },
      en_GB: {
        docsHeader: {
          label: 'Ultimi {months} Mesi'
        }
      }
    }
  },
  watch: {
    'defaultMonths': function (newVal, oldVal) {
      this.months = parseInt(newVal)
    }
  },
  computed: {
    showBack: function () {
      let root = this.$route.path
      if (this.$route.path.length === 1) {
        return false
      } else if (this.$route.name === 'DocumentiPers') {
        return false
      } else {
        return true
      }
    }
  },
  mounted: function () {
  },
  methods: {
    changeMonth: function (month) {
      this.$emit('changeMonth', month)
    },
    getLabel: function (item) {
      return this.$i18n.t('docsHeader.label', { months: item })
    }
  }
}
</script>

<style lang="less">
@import "../../assets/less/general.less";

.docs-header {
  height: 100%;

  /*height: 60px;
    line-height: 30px;
    position: relative;
    cursor: pointer;
    padding-top: 15px;
    padding-bottom: 15px;
    display: block;
    .return {
      height: 30px;
      .set-font(@color: @greenRiva, @weight: bold);
      .fa-icon {
        float: left;
      }
    }*/
  .title {
    height: 40px;
    line-height: 30px;
    position: relative;
    cursor: pointer;
    padding-top: 15px;
    padding-bottom: 15px;
    display: block;
    text-align: right;
    letter-spacing: 3px;
    text-transform: uppercase;
    .set-font(@size: 16px, @color: @textTable, @weight: bold, @family: 'os-regular');
    //height: 50px;
    //padding-top: 15px;
    padding: 0;
    padding-right: 10px;

    // padding-top: 10px;
    // padding-bottom: 10px;
    span {
      display: block;
      padding-top: 15px;
    }
  }

  .filter {
    height: 40px;
    margin-top: 20px;

    .month {
      width: 100%;
      //float: right;
      //width: 100%;
      //margin-top: 10px;
      //margin-right: 10px;

      .el-select {
        margin-left: 5px;
        margin-right: 5px;
        width: 250px;
        height: 22px;
        margin-bottom: 20px;

        .is-focus {
          border: 0px;
        }

        .el-input__inner {
          .set-font(@size: 14px, @weight: bold, @color: @textTable, @family: 'os-bold');
          text-align: center;
          height: 22px;
          line-height: 0px;
          padding-left: 0px;
          padding-right: 5px;
          border: 0px;
          border-radius: 0px;
          border-bottom: 1px solid @textTable;
          background-color: transparent;
          letter-spacing: 1px;
          padding-bottom: 10px;
        }

        .el-input__inner:focus {
          border: 0px !important;
          border-bottom: 1px solid @textTable !important;
        }

        .el-input__suffix {
          right: 0px;

          .el-input__icon {
            color: @textTable;
            font-size: 20px;
          }
        }
      }

      span {
        display: block;
        float: left;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Documenti/DocsHeader.vue